const alarmCharacterCodes: Record<string, string> = {
    '0': '00',
    '1': '01',
    '2': '02',
    '3': '03',
    '4': '04',
    '5': '05',
    '6': '06',
    '7': '07',
    '8': '08',
    '9': '09',
    ' ': '10',
    'Å': '11',
    'Ä': '12',
    'A': '13',
    'Æ': '14',
    'B': '15',
    'C': '16',
    'D': '17',
    'E': '18',
    'F': '19',
    'G': '20',
    'H': '22',
    'I': '23',
    'J': '24',
    'K': '25',
    'L': '26',
    'M': '27',
    'N': '28',
    'Ø': '29',
    'Ö': '30',
    'O': '31',
    'P': '33',
    'Q': '34',
    'R': '35',
    'S': '36',
    'T': '37',
    'U': '38',
    'Ü': '39',
    'V': '40',
    'W': '41',
    'X': '42',
    'Y': '44',
    'Z': '45',
    '.': '46',
    ',': '47',
    '/': '48',
    '-': '49',
    '+': '50',
    '&': '51',
    '(': '52',
    ')': '53'
};

export const maximumAlarmTextLength = 16;

/**
 * Converts text to Galaxy Dimension Appendix A character references. Each
 * reference is entered as two individual number keys.
 * The keypad opens its text editor in upper-case mode, so lower-case input is
 * deliberately normalised to upper case rather than changing keypad modes.
 */
export function encodeAlarmTextToKeySequence(text: string): string {
    const characters = Array.from(text);

    if (characters.length === 0) {
        throw new Error('Enter some text to send to the alarm.');
    }

    if (characters.length > maximumAlarmTextLength) {
        throw new Error(`Alarm text must be ${maximumAlarmTextLength} characters or fewer.`);
    }

    const unsupportedCharacters = Array.from(new Set(characters
        .map(character => character.toUpperCase())
        .filter(character => alarmCharacterCodes[character] === undefined)));

    if (unsupportedCharacters.length > 0) {
        throw new Error(`Unsupported alarm text character${unsupportedCharacters.length === 1 ? '' : 's'}: ${unsupportedCharacters.join(' ')}`);
    }

    return characters.flatMap(character =>
        Array.from(alarmCharacterCodes[character.toUpperCase()])
    ).join(',');
}
